import get from 'lodash/get';

/**
 * The `db` slice accessor lives in its own leaf module.
 *
 * Every entity selector module needs it, but they are also re-exported from
 * DB.selectors, so importing it from there would put ~50 modules in an import
 * cycle with that barrel — and cycles cause silent, chunking-dependent
 * initialisation-order bugs under ESM evaluation order.
 */
export const DOMAIN = 'db';

export const getStore = state => get(state, DOMAIN) || {};
